import { IRecipe } from "../../shared/Recipes";
import RecipeViewer from "./RecipeViewer";
import RecipeCache from "../../data/RecipeCache";
import { RecipeFullscreen } from "../Dialogs/FullscreenDlg";
import { useOverlay } from "../../gui/Overlay/OverlayProvider";
import Form from "../../gui/Form/Form";
import RecipeEditor from "./RecipeEditor";

export function RecipeDlg() {
    const {edit} = RecipeFullscreen.useFullscreen()
    const content = edit ? <Form defaultValid={true} defaultDirty={false}><RecipeEditor/></Form> : <RecipeViewer/>    
    return content
}

export default function useViewRecipe(){
    const {FullscreenDlg} = RecipeFullscreen
    const {addOverlay,hasOverlay,popOverlay} = useOverlay()

    const viewRecipe = (recipe:IRecipe|undefined) => recipe && !hasOverlay("recipe") && addOverlay("recipe", {
        modal: true,
        children:<FullscreenDlg overlayId="recipe" item={recipe} cache={RecipeCache.i} content={<RecipeDlg/>}/>,
        className:"dialog fullscreen"})

    const hideRecipe = () => popOverlay("recipe")

    return {viewRecipe,hideRecipe}
}